module.exports = __webpack_public_path__ + "img/qfecard-logo-white-dev.519edd87.svg";